/**
 * v4a — cabinet registrations (lower-cabinet, upper-cabinet).
 *
 * Kept in a separate file so v3 / v4b / v5 agents working in parallel
 * don't conflict on `index.js`. The main thread consolidates each
 * tier's registrations into `index.js` at merge time.
 *
 * Importing this module is a side-effect that mutates the shared
 * registry; consumers that need `getSchematicComponent` must import
 * `./index` (which in turn imports this file once merged).
 */
import { registerSchematic } from './registry';
import { LowerCabinetSchematic } from './LowerCabinetSchematic';
import { UpperCabinetSchematic } from './UpperCabinetSchematic';

registerSchematic('lower-cabinet', LowerCabinetSchematic);
registerSchematic('upper-cabinet', UpperCabinetSchematic);

export { LowerCabinetSchematic, UpperCabinetSchematic };
